import React from 'react';

const gameTitle = 'Six Shot Showdown';
const gameSubtitle = 'The Lacks gang and their lackeys have come around again. This isn\'t the first time they\'ve taken over these sands, but you\'re sure to make it the last. After making a dubious deal you gain the weapon you need to fight back. Six Shot Showdown is a puzzle based platformer game where your only tool is your legs, the environment and the six bullets in your chamber. Can you defeat the Lacks gang in time and keep your reputation intact?';
const howToPlay = 'Use A and D to move left and right, Space to jump, and the Mouse to aim and Left Click to shoot. Hold down the Right mouse button (or E) to enter Bullet Time. You have six bullets in your chamber, so use them wisely. The Lacks gang will be coming at you from all directions, so be sure to keep moving and stay on your toes. Good luck!';
const creators = [
  {
    name: 'AgentWebFoot',
    url: 'https://github.com/AgentWebFoot',
  },
  {
    name: 'StormCloakedScholar636',
    url: 'https://github.com/StormCloak34',
  },
  {
    name: 'Kashic',
    url: 'https://github.com/ZanyJake5',
  },
];
const creditItems = [
  {
    label: 'Strange Cowboy Platformer kit by FagelTomten',
    url: 'https://fageltomten.itch.io/strange-cowboy-platformer',
  },
  {
    label: 'Soundsnap',
    url: 'https://www.soundsnap.com/',
  },
  {
    label: 'Pixabay',
    url: 'https://pixabay.com/',
  },
  {
    label: 'SIL Open Fonts License',
    url: 'https://openfontlicense.org/',
  },
];
const creditsNote = 'License for the OFL is within the game under the License folder.';

const itchEmbedHtml = '<iframe frameborder="0" src="https://itch.io/embed-upload/18529256?color=503200" allowfullscreen="" width="640" height="380"><a href="https://agentwebfoot.itch.io/showdown">Play Six Shot Showdown on itch.io</a></iframe>';

const styles = {
  page: {
    width: '100%',
    overflowX: 'hidden',
    marginBottom: '50px',
    color: '#F3E5AB',
    fontFamily: 'Milonga, serif',
  },
  hero: {
    textAlign: 'center',
    padding: '24px 20px 12px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  title: {
    fontSize: '48px',
    marginBottom: '12px',
    textShadow: '0 3px 8px rgba(0, 0, 0, 0.8)',
    fontFamily: 'Rye, serif',
  },
  subtitle: {
    fontSize: '18px',
    maxWidth: '800px',
    margin: 0,
    lineHeight: 1.5,
    color: '#E6D6A8',
  },
  embedSection: {
    width: 'min(1100px, calc(100% - 32px))',
    margin: '24px auto 0',
    padding: '24px',
    border: '2px solid rgba(192, 169, 107, 0.7)',
    borderRadius: '18px',
    background: 'rgba(34, 24, 16, 0.72)',
    boxShadow: '0 16px 36px rgba(0, 0, 0, 0.35)',
  },
  embedInner: {
    width: '100%',
    minHeight: '360px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholder: {
    minHeight: '360px',
    width: '100%',
    border: '2px dashed rgba(243, 229, 171, 0.55)',
    borderRadius: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    textAlign: 'center',
    lineHeight: 1.7,
    fontSize: '22px',
    background: 'rgba(0, 0, 0, 0.2)',
  },
  content: {
    textAlign: 'left',
    padding: '40px 36px 0',
    maxWidth: '800px',
    margin: '0 auto',
  },
  sectionTitle: {
    fontSize: '36px',
    marginBottom: '20px',
    textShadow: '0 2px 6px rgba(0, 0, 0, 0.75)',
    fontFamily: 'Rye, serif',
  },
  text: {
    fontSize: '18px',
    maxWidth: '800px',
    margin: 0,
    lineHeight: 1.7,
    color: '#E6D6A8',
  },
  creditsText: {
    fontSize: '18px',
    maxWidth: '800px',
    margin: 0,
    lineHeight: 1.7,
    color: '#E6D6A8',
  },
  creditsList: {
    margin: '16px 0 0',
    paddingLeft: '24px',
  },
  creditItem: {
    marginBottom: '10px',
  },
  creditLink: {
    color: '#E0C27A',
  },
  inlineCreditLink: {
    color: '#E0C27A',
    textDecoration: 'underline',
  },
  creditsNote: {
    fontSize: '18px',
    maxWidth: '800px',
    margin: '16px 0 0',
    lineHeight: 1.7,
    color: '#E6D6A8',
  },
};

const SixShotShowdown = () => {
  const hasEmbed = itchEmbedHtml.trim().length > 0;

  return (
    <div style={styles.page}>
      <div style={styles.hero}>
        <h1 style={styles.title}>{gameTitle}</h1>
      </div>

      <div style={styles.embedSection}>
        <div style={styles.embedInner}>
          {hasEmbed ? (
            <div dangerouslySetInnerHTML={{ __html: itchEmbedHtml }} />
          ) : (
            <div style={styles.placeholder}>
              <code>itchEmbedHtml</code>
              {' '}<code>src/pages/projects/ItchGame.jsx</code>.
            </div>
          )}
        </div>
      </div>

      <div style={styles.content}>
        <p style={styles.subtitle}>{gameSubtitle}</p>
        <h2 style={styles.sectionTitle}>How to Play</h2>
        <p style={styles.text}>{howToPlay}</p>

        <h2 style={{ ...styles.sectionTitle, margin: '40px 0 20px' }}>Credits</h2>
        <p style={styles.creditsText}>
          This game was created by{' '}
          {creators.map((creator, index) => (
            <React.Fragment key={creator.name}>
              {index > 0 && (index === creators.length - 1 ? ', and ' : ', ')}
              <a href={creator.url} target="_blank" rel="noreferrer" style={styles.inlineCreditLink}>
                {creator.name}
              </a>
            </React.Fragment>
          ))}
          {' '}for the GMTK 2026 Game Jam.
        </p>
        <p style={{ ...styles.creditsText, marginTop: '16px' }}>The following assets were used:</p>
        <ul style={styles.creditsList}>
          {creditItems.map((item) => (
            <li key={item.url} style={styles.creditItem}>
              <a href={item.url} target="_blank" rel="noreferrer" style={styles.creditLink}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <p style={styles.creditsNote}>{creditsNote}</p>
      </div>
    </div>
  );
};

export default SixShotShowdown;
